import i18n from "~/i18n/i18n";

export type TranslateKey = (key: string) => string;

const translateWithActiveLanguage: TranslateKey = (key) => i18n.t(key, { ns: "common" });

const localizedText = (text: string, key?: string, translate: TranslateKey = translateWithActiveLanguage): string =>
	key ? translate(key) : text;

export { translateWithActiveLanguage };
export default localizedText;
